import script from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"

import "./PreferenceView.vue?vue&type=style&index=0&id=c64e96c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64e96c0"]])

export default __exports__